import { render } from "./index.vue?vue&type=template&id=106d9310"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=106d9310&lang=scss"

import exportComponent from "/Users/user/Desktop/work_projects/cc-faq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__